import { PropsWithChildren } from 'react';
import { Typography } from '../../../../design-system/components/typography/typography';

type TitledPageProps = {
  title: JSX.Element | string;
  rightContent?: JSX.Element | null;
  className?: string;
  customComponent?: React.ReactNode;
};

export const TitledPage = (p: PropsWithChildren<TitledPageProps>) => (
  <div className={'h-[calc(100%-40px)] ' + (p.className || 'max-w-[1600px]')}>
    <div className="flex row justify-between flex-wrap">
      <div className="flex items-center">
        <Typography variant="headline" size="large" id="page-title">
          {p.title}
        </Typography>
        {p?.customComponent || null}
      </div>
      <div className="flex justify-end items-center">{p.rightContent}</div>
    </div>
    <div className="my-5 2xl:my-10 h-full">{p.children}</div>
  </div>
);
